import { /*LOCALE_ID, */NgModule } from '@angular/core';
// import { registerLocaleData } from '@angular/common';
// import localeIt from '@angular/common/locales/it';
//
// registerLocaleData(localeIt, 'it');

// modules (angular)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

// modules
import { AppRoutingModule } from './app-routing.module';
// import { BlocksModule } from './modules/blocks/blocks.module';
// import { FooterModule } from './modules/footer/footer.module';
// import { HeaderModule } from './modules/header/header.module';
// import { MobileModule } from './modules/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';
// import { WidgetsModule } from './modules/widgets/widgets.module';

// components
import { AppComponent } from './app.component';
// import { RootComponent } from './components/root/root.component';

// pages
// import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
// import { PageHomeTwoComponent } from './pages/page-home-two/page-home-two.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { RootComponent } from './components/root/root.component';
import { BlocksModule } from './modules/blocks/blocks.module';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { WidgetsModule } from './modules/widgets/widgets.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './services/interceptor.service';
import { MatSortModule } from '@angular/material/sort';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthModule } from './modules/auth/auth.module';
import { CommissionsReportComponent } from './modules/reports/commissions-report/commissions-report.component';
import { RecoveryFeeWorkoutComponent } from './modules/reports/recovery-fee-workout/recovery-fee-workout.component';
import { BillingModule } from './modules/Billing/billing.module';
import { MultiInputFieldsComponent } from './shared/components/multi-input-fields/multi-input-fields.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectFilterModule } from 'mat-select-filter';
import { InstallationActivationReportComponent } from './modules/reports/installation-activation-report/installation-activation-report.component';
import { HcCustomerReportComponent } from './modules/reports/hc-customer-report/hc-customer-report.component';
import { SuspensionReportComponent } from './modules/reports/suspension-report/suspension-report.component';
import { AdditionalInfoReportComponent } from './modules/reports/additional-info-report/additional-info-report.component';
import { CustomerRiskReportComponent } from './modules/reports/customer-risk-report/customer-risk-report.component';
import { OverdueCancellationReportComponent } from './modules/reports/overdue-cancellation-report/overdue-cancellation-report.component';
import { RejectedCancellationsReportComponent } from './modules/reports/rejected-cancellations-report/rejected-cancellations-report.component';
import { ShopOrdersReportComponent } from './modules/reports/shop-orders-report/shop-orders-report.component';
import { CancellationReportComponent } from './modules/reports/cancellation-report/cancellation-report.component';
import { DispatchReportComponent } from './modules/reports/dispatch-report/dispatch-report.component';
import { DeviceDispatchReportComponent } from './modules/reports/device-dispatch-report/device-dispatch-report.component';
import { AgeingReportComponent } from './modules/reports/ageing-report/ageing-report.component';
import { SpRequestCountReportComponent } from './modules/reports/sp-request-count-report/sp-request-count-report.component';
import { MoveAddressReportComponent } from './modules/reports/move-address-report/move-address-report.component';
import { CollectionsAgeingReportComponent } from './modules/reports/collections-ageing-report/collections-ageing-report.component';
import { PaymentArrangementReportComponent } from './modules/reports/payment-arrangement-report/payment-arrangement-report.component';
import { AdditionalFeaturesModule } from "./modules/Additional-Features/Additional-Features.module";

import { MsalModule, MSAL_INSTANCE, MsalService, MsalGuard, MsalBroadcastService, MsalInterceptor, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalRedirectComponent, MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { MicrosoftLoginRedirectionComponent } from './modules/auth/microsoft-login-redirection/microsoft-login-redirection.component';
import { AuthGuard } from './guard/auth.guard';
import { environment } from 'src/environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.Microsoft.clientId,
            authority: environment.Microsoft.authority,
            redirectUri: environment.Microsoft.redirectUri,
            navigateToLoginRequestUrl: false
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false,
        }
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['openid', 'profile', 'email']
        }
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
    // Add your API URL here to ensure tokens are attached to calls
    protectedResourceMap.set('https://dev.home-connect.co.za/HomeWebapi/api/login', null);
    protectedResourceMap.set('https://dev.home-connect.co.za/HomeWebapi/api/auth/*', null);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}
@NgModule({
    declarations: [
        AppComponent,
        RootComponent,
        PageNotFoundComponent,
        CommissionsReportComponent,
        RecoveryFeeWorkoutComponent,
        MultiInputFieldsComponent,
        InstallationActivationReportComponent,
        HcCustomerReportComponent,
        SuspensionReportComponent,
        AdditionalInfoReportComponent,
        CustomerRiskReportComponent,
        OverdueCancellationReportComponent,
        RejectedCancellationsReportComponent,
        ShopOrdersReportComponent,
        CancellationReportComponent,
        DispatchReportComponent,
        DeviceDispatchReportComponent,
        AgeingReportComponent,
        SpRequestCountReportComponent,
        MoveAddressReportComponent,
        CollectionsAgeingReportComponent,
        PaymentArrangementReportComponent,
        MicrosoftLoginRedirectionComponent,

    ],
    imports: [
        // modules (angular)
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        MatSortModule,
        MatDividerModule,
        // modules (third-party)
        CarouselModule,
        ToastrModule.forRoot(),
        // modules
        AppRoutingModule,
        BlocksModule,
        FooterModule,
        HeaderModule,
        MobileModule,
        WidgetsModule,
        SharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatRadioModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatSelectModule,
        MatTooltipModule,
        MatDialogModule,
        // AuthModule - This should be lazy-loaded via AppRoutingModule
        BillingModule,
        NgMultiSelectDropDownModule.forRoot(),
        MatSlideToggleModule,
        MatSelectFilterModule,
        MsalModule.forRoot(
            MSALInstanceFactory(),
            MSALGuardConfigFactory(),
            MSALInterceptorConfigFactory()
        ),
        //NgbModule,
        //NgbModule
        AdditionalFeaturesModule
    ],
    providers: [
        // { provide: LOCALE_ID, useValue: 'it' }
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalGuard,
        MsalService,
        MsalBroadcastService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
